import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/scss/comman.scss";
import mixpanel from "mixpanel-browser";

// Initialize Mixpanel with your project token

// Create a wrapper for user identification
export const identifyUser = (userId, userProperties = {}) => {
  if (userId) {
    mixpanel.identify(userId);
    mixpanel.people.set({
      $name: userProperties.name,
      $email: userProperties.email,
      $last_login: new Date().toISOString(),
      ...userProperties,
    });

    // Only start session recording if user is not a tester
    if (!userProperties.email?.toLowerCase().includes("tester")) {
      mixpanel.start_session_recording();
    } else {
      // Stop recording if it was started
      mixpanel.stop_session_recording();
    }
  }
};

// Create a wrapper for tracking events
export const trackEvent = (eventName, properties = {}) => {
  // mixpanel.track(eventName, {
  //   ...properties,
  //   timestamp: new Date().toISOString()
  // });
};

// Check for existing user session on app load
const checkExistingUser = () => {
  const userValues = localStorage.getItem("userValues");
  if (userValues) {
    try {
      const userData = JSON.parse(userValues);
      if (!userData.user_email?.toLowerCase().includes("tester")) {
        mixpanel.init("c5fd8b34885f1f2fa90ef0c44213ba11", {
          debug: false,
          track_pageview: false,
          record_heatmap_data: true,   // Enable Heatmap data collection
          ignore_dnt: true,
          persistence: "localStorage",
          // Session recording configuration
          record_sessions_percent: 100,
          record_session: true,
          session_timeout: 30 * 60 * 1000,
          // Enable automatic tracking
          track_forms: false,
          track_links: false,
          // Session replay specific options
          record_mask_text_selector: 'input[type="password"]',
          record_block_class: "mixpanel-block",
          record_canvas: true,
          record_cross_origin_iframes: true,
          record_inputs: true,
          record_mouse_movements: true,
          record_scroll: true,
          record_timing: true,
          api_host: "https://api-eu.mixpanel.com",
        });
        // Identify user in Mixpanel
        identifyUser(userData.uid, {
          name: userData.first_name + " " + userData.last_name,
          email: userData.user_email,
          user_level: userData.level,
          signup_type: userData.signUpType,
        });

        // Track login event
        trackEvent("User Logged In", {
          user_id: userData.uid,
          user_level: userData.level,
          signup_type: userData.signUpType,
        });
      } else {
        mixpanel.stop_session_recording();
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }
};

// Check for existing user on app load
checkExistingUser();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
